import React, { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  AccordionTileCont,
  QuestionsNo,
  TileActionIconCont,
  TileBody,
  TileBodyText,
  TileExpandIconCont,
  TileIconCont,
  TileInfoArea,
  TileTitle,
  TitleCont,
} from './AccordionTile.styles';
import Tooltip from '../../../HOC/Tooltip/Tooltip';
import { IAccordionItem } from '../../../hooks/useAccordion';
import Arrow from '@/assets/icons/arrowRightIcon.svg?react';
import InfoIcon from '@/assets/icons/infogrey.svg?react';
import CircleMinus from '@/assets/icons/minusInCircle.svg?react';
import CirclePlus from '@/assets/icons/plusInCircle.svg?react';

interface IAccordionTile {
  item: IAccordionItem;
  setActive: (state: string) => void;
  active?: boolean;
  notAssigned?: boolean;
  changeItemAssigment: (id: string) => void;
  setIsTransitionBlocked: React.Dispatch<React.SetStateAction<boolean>>;
  scrollId: string;
}
const AccordionTile: FC<IAccordionTile> = ({
  item,
  active,
  setActive,
  notAssigned,
  changeItemAssigment,
  setIsTransitionBlocked,
  scrollId,
}) => {
  const { items } = item;
  const numberOfQuestion = (items && items?.length) || 0;
  const { t } = useTranslation();
  const changeAssigment = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    changeItemAssigment(item.id);
    setIsTransitionBlocked(true);
  };

  const renderTileBody = useMemo(
    () =>
      items?.map(({ id, name }) => (
        <TileBodyText key={id} id={id}>
          {name || ''}
        </TileBodyText>
      )),
    [items]
  );

  return (
    <>
      <AccordionTileCont
        data-testid="accordionTile"
        active={active}
        onClick={() => setActive(item.id)}
        notAssigned={notAssigned}
        id={scrollId}
      >
        <TileExpandIconCont id="TileExpandIconCont" active={active}>
          <Arrow />
        </TileExpandIconCont>
        <TileInfoArea id="TileInfoArea">
          <TitleCont id="TitleCont">
            <TileTitle id="TileTitle">{item.name}</TileTitle>
            <TileIconCont id="TileIconCont">
              <Tooltip tooltipDesc={(item.shortDescription as React.ReactNode) || ''}>
                <InfoIcon />
              </Tooltip>
            </TileIconCont>
          </TitleCont>
          <QuestionsNo id="QuestionsNo">
            {numberOfQuestion} {t('viewSurvey.contents.questions').toLowerCase()}
          </QuestionsNo>
          <TileActionIconCont data-testid="assigmentButton" onClick={changeAssigment}>
            {!notAssigned ? <CircleMinus /> : <CirclePlus />}
          </TileActionIconCont>
        </TileInfoArea>
      </AccordionTileCont>
      {active && (
        <TileBody id="TileBody" notAssigned={notAssigned}>
          {renderTileBody}
        </TileBody>
      )}
    </>
  );
};

export default AccordionTile;
